import { Api } from 'domain/core';
import { AuthorizationService } from 'domain/services';
import { useAuthToken } from './useAuth';
import useFetch from 'domain/services/auth/fetch.service';

export const useLogin = () => {
	const setToken = useAuthToken((s) => s.setToken);

	const doLogin = ({
		password,
		username,
	}: {
		password: string;
		username: string;
	}): Promise<any> => {
		return fetch(Api.baseUrl + Api.auth.login, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ username, password }),
		})
			.then((r) => {
				if (r.status === 200) {
					return r.json();
				}
				throw new Error(r.statusText);
			})
			.then((token) => {
				AuthorizationService.saveAuthorization({ ...token, expires_in: 50000 });

				// Set in the state
				setToken({ ...token, expires_in: 50000 });
			});
	};

	return doLogin;
};

export const useLoginAs = () => {
	const setToken = useAuthToken((s) => s.setToken);

	const authFetch = useFetch();

	const doLogin = (userId: string | number): Promise<any> => {
		return authFetch(`${Api.baseUrl}${Api.auth.loginAs}/${userId}`)
			.then((r) => {
				if (r.status === 200) {
					return r.json();
				}
				throw new Error(r.statusText);
			})
			.then((token) => {
				AuthorizationService.saveAuthorization({ ...token, expires_in: 50000 });

				// Set in the state
				setToken({ ...token, expires_in: 50000 });
			});
	};

	return doLogin;
};
